import { format, isSameDay } from "date-fns";
import locale from "date-fns/locale/nb";
import Button from 'src/components/button/Button';
import CalendarSvg from 'src/components/svg/CalendarSvg';
import { useProgramDatesContext } from 'src/lib/contexts/ProgramDatesWrapper';
import classNames from 'classnames';
import styles from './NoShows.module.css';

//#region [Props]
type NoShowsProps = {
  className?: string;
};
//#endregion

//#region [Component]
export default function NoShows({ className }: NoShowsProps) {
  const datesContext = useProgramDatesContext();

  let content: React.ReactNode;

  let showNextShowDate = false;

  if ((datesContext?.availableDates?.length ?? 0) > 0) {
    showNextShowDate = true;
    if (datesContext.selectedDate && !datesContext.availableDates!.some(d => isSameDay(d, datesContext.selectedDate!))) {
      content = <>Ingen forestillinger for {format(datesContext.selectedDate, 'd. MMMM', { locale })}</>;

    }
  } else {
    content = <>Ingen forestillinger tilgjengelig for valgt kinosted</>;
  }

  return <div className={classNames(styles.NoShows, className)}>
    <div className={styles.Text}>
      {content}
      {showNextShowDate && <div>Neste dag med film på programmet er <Button
        className={styles.DateSelectorButton}
        text={format(new Date(datesContext.availableDates![0]), "iiii d. MMMM", { locale })}
        onClick={() => datesContext.setSelectedDate(datesContext.availableDates![0])}
        icon={<CalendarSvg className={styles.CalendarSvg} />}
        inverse />
      </div>}
    </div>
  </div>;
}
//#endregion

